import { Modal } from 'ant-design-vue'
import { createVNode } from 'vue'

import { SvgIcon } from '..'

/**
 * 弹窗确认
 * @param options 弹窗配置
 * @returns
 */
export function ModalConfirm(options: {
  title: string
  content: string
  okText?: string
  okType?: string
  okButtonProps?: { [key: string]: unknown }
  cancelButtonProps?: { [key: string]: unknown }
  cancelText?: string
  wrapClassName?: string
  closable?: boolean
  width?: string
  zIndex?: number
  onOk?: () => void
  onCancel?: () => void
}) {
  const {
    title,
    content,
    okText,
    okButtonProps,
    cancelText,
    cancelButtonProps,
    wrapClassName,
    closable,
    width,
    zIndex,
    onOk,
    onCancel,
  } = options

  return new Promise<void>((resolve, reject) => {
    Modal.confirm({
      title,
      icon: createVNode(SvgIcon, { name: 'ai-attention', size: '22px', class: 'anticon anticon-exclamation-circle' }),
      content,
      width,
      zIndex: zIndex || 1101,
      okText: okText || '确定',
      okButtonProps: okButtonProps || {},
      cancelText: cancelText || '取消',
      cancelButtonProps: cancelButtonProps || {},
      centered: true,
      wrapClassName: wrapClassName || '',
      closable: closable || false,
      onOk:
        onOk
        || (() => {
          resolve()
        }),
      onCancel:
        onCancel
        || (() => {
          reject(new Error('cancel'))
          Modal.destroyAll()
        }),
    })
  })
}
